import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiProperty, ApiTags } from "@nestjs/swagger";
import { EmployeeWeekOffUploadsService } from "./employee-week-off-uploads.service";
import { EmployeeWeekOffUploadsDTO } from "./employee-week-off-uploads-dto";
import { EmployeeWeekOffUploadsResponseModel } from "libs/shared-models/hrms/src/lib/employee-week-off-uploads/employee-week-off-uploads-response-model";
import { CommonResponse, EmployeeCodeRequest } from "@gtpl/shared-models/masters";



@ApiTags('employee-week-off-uploads')
@Controller('employee-week-off-uploads')
export class EmployeeWeekOffUploadsController {
    constructor(
        private service: EmployeeWeekOffUploadsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }



    @Post('/EmployeeWeekOffUploadsExcel')
    @ApiBody({type:EmployeeWeekOffUploadsDTO})
    async EmployeeWeekOffUploadsExcel(@Body() data:any): Promise<EmployeeWeekOffUploadsResponseModel>{
       try{
        return this.service.EmployeeWeekOffUploadsExcel(data);
       } catch(err){
        return this.applicationExceptionHandler.returnException(EmployeeWeekOffUploadsResponseModel,err);
       }
    }


    @Post('/getEmployeeWeekOffUploads')
    async getEmployeeWeekOffUploads(): Promise<EmployeeWeekOffUploadsResponseModel> {
        try {
            return this.service.getEmployeeWeekOffUploads();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(EmployeeWeekOffUploadsResponseModel, err);

        }
    }
    @Post('/getWeekOffByEmpCode')
    async getWeekOffByEmpCode(@Body() req :EmployeeCodeRequest):Promise<CommonResponse>{
        try{
            return this.service.getWeekOffByEmpCode(req);
        }catch (err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

}